// Wishlist config
var wishlistVersion = '1.0';
var wishlistItemsLimit = 0;
var wishlistItemsLimitByIdentifier = 3;

// Selectors
var wishlistMessageEmpty = document.querySelector('[data-wishlist-message="empty"]');
var wishlistActionClear = document.querySelector('[data-wishlist-action="clear"]');
var wishlistActionReset = document.querySelector('[data-wishlist-action="reset"]');
var wishlistActionRequest = document.querySelector('[data-wishlist-action="request"]');

/**
 * Handling events
 */
var wishlistChangedEvent = new Event('wishlistChanged');

//
window.load = updateWishlist();

//
document.querySelectorAll('[data-wishlist-action="add"]').forEach(item => {
    item.addEventListener('click', event => {
        event.preventDefault();

        var identifier = event.target.getAttribute('data-wishlist-item-identifier');
        var label = event.target.getAttribute('data-wishlist-item-label');
        var properties = event.target.getAttribute('data-wishlist-item-properties');
        if (properties)
            properties = JSON.parse(properties);

        // Ignore item if the identifier or label is empty
        if (!identifier || !label) return;

        addItemToWishlist(identifier, label, properties);
    }, false);
});

//
var wishlistActionsRemove = document.querySelectorAll('[data-wishlist-action="remove"]');
wishlistActionsRemove.forEach(item => {
    item.addEventListener('click', event => {
        event.preventDefault();

        var identifier = event.target.getAttribute('data-wishlist-item-identifier');

        // Ignore it if the node identifier is empty
        if (!identifier) return;

        removeItemFromWishlist(identifier);
    }, false);
});

//
var wishlistActionsIncrease = document.querySelectorAll('[data-wishlist-action="increase"]');
wishlistActionsIncrease.forEach(item => {
    item.addEventListener('click', event => {
        event.preventDefault();

        var identifier = event.target.getAttribute('data-wishlist-item-identifier');
        if (!identifier) return;

        updateItemOnWishlist(identifier, '', [], 1);
    }, false);
});

//
var wishlistActionsDecrease = document.querySelectorAll('[data-wishlist-action="decrease"]');
wishlistActionsDecrease.forEach(item => {
    item.addEventListener('click', event => {
        event.preventDefault();

        var identifier = event.target.getAttribute('data-wishlist-item-identifier');
        if (!identifier) return;

        updateItemOnWishlist(identifier, '', [], -1);
    }, false);
});

if (wishlistActionClear) {
    wishlistActionClear.addEventListener('click', function (event) {
        event.preventDefault();
        localStorage.removeItem('wishlist');
        updateWishlist();
        document.dispatchEvent(wishlistChangedEvent);
    }, false);
}

if (wishlistActionReset) {
    localStorage.removeItem('wishlist');
    updateWishlist();
}

/**
 *
 * @returns {array|null}
 */
function getWishlist() {
    var wishlist = localStorage.getItem('wishlist');
    if (wishlist) return JSON.parse(wishlist);
    return null;
}

/**
 *
 * @returns {number}
 */
function countWishlistItems() {
    var wishlist = getWishlist();
    var count = 0;
    if (!wishlist) return count;
    wishlist.items.forEach(item => {
        count += item.quantity;
    });
    return count;
}

/**
 *
 * @param identifier
 * @param label
 * @param properties
 * @param quantity
 */
function addItemToWishlist(identifier, label, properties = [], quantity = 1) {

    if (wishlistItemsLimit && wishlistItemsLimit <= countWishlistItems()) {
        console.log('Maximum number of wishlist items has been reached. (Limit: ' + wishlistItemsLimit + ')');
        return;
    }
    var itemAlreadyOnWishlist = getItemFromWishlist(identifier);
    if (itemAlreadyOnWishlist) {
        if (wishlistItemsLimitByIdentifier && wishlistItemsLimitByIdentifier <= itemAlreadyOnWishlist.quantity) {
            console.log('Wishlist item with identifier "' + identifier + '" already exists. (Limit by identifier: ' + wishlistItemsLimitByIdentifier + ')');
            return;
        }
        return updateItemOnWishlist(identifier, label, properties, quantity);
    }

    var wishlist = getWishlist();
    if (!wishlist) {
        // Initialize wishlist
        wishlist = {};
        wishlist.dateCreated = Date.now();
        wishlist.dateUpdated = null;
        wishlist.version = wishlistVersion;
        wishlist.items = [];
    }

    var item = {};
    item.identifier = identifier;
    item.label = label;
    item.properties = properties;
    item.quantity = quantity;
    item.dateAdded = Date.now();
    item.dateUpdated = null;

    wishlist.items.push(item);
    wishlist.dateUpdated = Date.now();
    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    updateWishlist();
    document.dispatchEvent(wishlistChangedEvent);
}

/**
 *
 * @param identifier
 */
function getItemFromWishlist(identifier) {
    var wishlist = getWishlist();
    if (!wishlist) return null;

    for (var i = 0; i < wishlist.items.length; i++) {
        if (wishlist.items[i].identifier !== identifier)
            continue;
        return wishlist.items[i];
    }
}

/**
 *
 * @param identifier
 * @param label
 * @param properties
 * @param quantity
 */
function updateItemOnWishlist(identifier, label, properties = [], quantity = 1) {
    var wishlist = getWishlist();
    if (!wishlist) return;

    for (var i = 0; i < wishlist.items.length; i++) {
        if (wishlist.items[i].identifier !== identifier)
            continue;

        if (label)
            wishlist.items[i].label = label;
        if (properties.length)
            wishlist.items[i].properties = properties;

        if (wishlist.items[i].quantity + quantity >= 1) {
            wishlist.items[i].quantity += quantity;
            wishlist.items[i].dateUpdated = Date.now();
        }
    }
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    updateWishlist();
    document.dispatchEvent(wishlistChangedEvent);
}

/**
 *
 */
function setWishlistFormElement () {
    var wishlist = localStorage.getItem('wishlist');
    if (!wishlist) return;
    try {
        var wishlistFormElement = document.querySelector('[data-wishlist-form-element]');
        if (!wishlistFormElement) return;

        wishlistFormElement.value = wishlist;
    } catch(e) {
        //
    }
}

/**
 *
 * @param identifier
 */
function removeItemFromWishlist(identifier) {
    var wishlist = getWishlist();
    var updatedItems = [];
    if (!wishlist) return;

    for (var i = 0; i < wishlist.items.length; i++) {
        if (wishlist.items[i].identifier === identifier)
            continue;

        updatedItems.push(wishlist.items[i]);
    }
    wishlist.items = updatedItems;
    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    updateWishlist();
    document.dispatchEvent(wishlistChangedEvent);
}

/**
 *
 */
export function updateWishlist() {
    // Update wishlist items
    var wishlist = getWishlist();
    var wishlistItems = document.querySelector('#wishlist-items');

    if (!wishlist) {
        wishlistItems.innerHTML = '';
    } else {

        // TODO: make template replacement more flexible, less hardcoded
        var wishlistItemTemplate = document.getElementById('wishlist-list-item-template');
        var wishlistItemTemplateHtml = wishlistItemTemplate.innerHTML;
        var wishlistItemsMarkup = '';
        var dataObject = wishlist.items;
        for (var key in dataObject) {
            wishlistItemsMarkup += wishlistItemTemplateHtml
                .replace(/%identifier%/g, dataObject[key].identifier)
                .replace(/%label%/g, dataObject[key].label)
                .replace(/%quantity%/g, dataObject[key].quantity)
                .replace(/%properties.title%/g, dataObject[key].properties.title)
                .replace(/%properties.subtitle%/g, dataObject[key].properties.subtitle)
                .replace(/%properties.thumbnail%/g, dataObject[key].properties.thumbnail)
                .replace(/%properties.href%/g, dataObject[key].properties.href);
        }

        wishlistItems.innerHTML = wishlistItemsMarkup;

        // TODO: duplicated! needs better implementation (see document.querySelectorAll('[data-wishlist-action="remove"]')...)
        var wishlistActionsRemove = wishlistItems.querySelectorAll('[data-wishlist-action="remove"]');
        wishlistActionsRemove.forEach(item => {
            item.addEventListener('click', event => {
                event.preventDefault();

                var identifier = event.target.getAttribute('data-wishlist-item-identifier');

                // Ignore it if the node identifier is empty
                if (!identifier) return;

                removeItemFromWishlist(identifier);
            }, false);
        });
        var wishlistActionsIncrease = wishlistItems.querySelectorAll('[data-wishlist-action="increase"]');
        wishlistActionsIncrease.forEach(item => {
            item.addEventListener('click', event => {
                event.preventDefault();

                var identifier = event.target.getAttribute('data-wishlist-item-identifier');
                if (!identifier) return;

                updateItemOnWishlist(identifier, '', [], 1);
            }, false);
        });
        var wishlistActionsDecrease = wishlistItems.querySelectorAll('[data-wishlist-action="decrease"]');
        wishlistActionsDecrease.forEach(item => {
            item.addEventListener('click', event => {
                event.preventDefault();

                var identifier = event.target.getAttribute('data-wishlist-item-identifier');
                if (!identifier) return;

                updateItemOnWishlist(identifier, '', [], -1);
            }, false);
        });
    }

    // Update wishlist counter and related elements
    var numberOfWishlistItems = countWishlistItems();
    document.querySelectorAll('[data-wishlist-counter]').forEach(item => {
        item.innerHTML = numberOfWishlistItems;
    });

    if (numberOfWishlistItems !== 0) {
        if (wishlistMessageEmpty) wishlistMessageEmpty.classList.add('d-none');
        if (wishlistActionClear) wishlistActionClear.classList.remove('d-none');
        if (wishlistActionRequest) wishlistActionRequest.classList.remove('disabled');
    } else {
        if (wishlistMessageEmpty) wishlistMessageEmpty.classList.remove('d-none');
        if (wishlistActionClear) wishlistActionClear.classList.add('d-none');
        if (wishlistActionRequest) wishlistActionRequest.classList.add('disabled');
    }

    // Update all related action elements
    var wishlistIdentifiers = [];
    if (wishlist) {
        for (var i = 0; i < wishlist.items.length; i++) {
            wishlistIdentifiers.push(wishlist.items[i].identifier);
        }
    }
    document.querySelectorAll('[data-wishlist-action="toggle"]').forEach(item => {

        var addAction = item.querySelector('[data-wishlist-action="add"]');
        var removeAction = item.querySelector('[data-wishlist-action="remove"]');

        addAction.classList.remove('d-none');
        removeAction.classList.add('d-none');

        if (wishlistIdentifiers.indexOf(addAction.getAttribute('data-wishlist-item-identifier')) !== -1) {
            addAction.classList.add('d-none');
            removeAction.classList.remove('d-none');
        }
    });

    setWishlistFormElement();
}